module.exports = __webpack_public_path__ + "static/media/kneenetic-5.162a2302.jpg";